import { message } from "antd";
import { toLogin } from "./utils";

const UNAUTHORIZED_CODE = 401;

export function handleServerError(err: any, defaultMessage: string = "") {
  if (err.response?.data?.status === UNAUTHORIZED_CODE) {
    toLogin();
    return;
  }
  const msg = getErrorMessage(err);
  message.error(msg, 3);
  console.error(err);
}

export function getErrorMessage(err: any, defaultMessage: string = "") {
  let msg = "";
  if (!!err.response) {
    msg = !!err.response.data ? err.response.data.message : err.response;
  }
  return msg ?? defaultMessage ?? "We failed to complete your last action. Please try again after a few seconds or contact us.";
}
